import {
	getCandidatePrimaryProfile,
	getProfileViews,
	getProfileCompletion,
	getProfileTopTabs,
	dynamicMandetoryFields,
	dynamicMandetoryFieldsForNew,
} from "@/utils/apiFunctions";
import { methods } from "vue-popperjs";
import { mapGetters } from "vuex";
const TEMP_FILTERS = {
	experience: [],
	jobType: [],
	locations: [],
	skills: [],
};

export default {
	beforeCreate() { },
	props: {},
	data() {
		return {
			isLaptop: true,
			setCountCourse: null,
			setCountJobs: null,
			setCountAssess: null,
			candidateData: {},
			profileViews: {},
			candidateProgress: null,

			//For common check mandetory Fields
			checkDynamicField: {},
			dynamicTabsScale: [],
			passDynamicScale: [],
			pinkFilled: [],
			finalIndexToCheckPinkFill: null,
			scaleTopSuccess: false,
			allFilledTabs: null,
		};
	},
	created() {
		this.getCandidatePrimaryProfile();
		this.detectZoomLevel();
	},
	mounted() {
		window.addEventListener("resize", this.detectZoomLevel);
	},
	beforeDestroy() {
		window.removeEventListener("resize", this.detectZoomLevel);
	},
	methods: {
		detectZoomLevel() {
			this.isLaptop = window.innerWidth >= 1024;
			console.log(window.devicePixelRatio);
			if (window.devicePixelRatio > 1.25 && this.isLaptop) {
				//only at 150
				this.setCountCourse = 4;
				this.setCountJobs = 5;
				this.setCountAssess = 8;
			} else if (window.devicePixelRatio <= 0.9 && this.isLaptop) {
				// < 100 -> 90 & 80
				this.setCountCourse = 5;
				this.setCountJobs = 7;
				this.setCountAssess = 8;
			} else if (window.devicePixelRatio < 1.25 && this.isLaptop) {
				this.setCountCourse = 4;
				this.setCountJobs = 6;
				this.setCountAssess = 8;
			} else {
				// Only 125
				this.setCountCourse = 3;
				this.setCountJobs = 4;
				this.setCountAssess = 6;
			}
			this.$forceUpdate();
		},

		async getCandidatePrimaryProfile() {
			try {
				const res = await getCandidatePrimaryProfile();
				if (res.status === 200) {
					this.candidateData = res.data.data;
					this.$store.commit("candidateVUEX/setPrimaryProfile", res.data.data);
				} else {
					this.candidateData = {};
					throw new Error("Could not get candidate data");
				}
			} catch (error) {
				console.error(error);
			}
		},
		capitalizeFirstLetter(value) {
			if (!value) return "";
			return value.charAt(0).toUpperCase() + value.slice(1);
		},
		async getProfileDetails() {
			try {
				const res = await getProfileViews();
				if (res.status == 200) {
					this.profileViews = res.data.data;
				} else {
					console.log("error in Views api");
				}
			} catch (error) {
				console.log(error);
			}
		},
		async profileCompletion(myCandData) {
			try {
				// await this.getCandidatePrimaryProfile();
				const response = await getProfileCompletion(myCandData._id);
				const candProgressResp = response.data.data;
				this.candidateProgress = candProgressResp.progress;
				this.$store.commit(
					"candidateVUEX/updateCandidateProgress",
					candProgressResp
				);
			} catch (error) {
				console.log(error);
			}
		},

		async getDynamicMandetoryFields(myCandInfo) {
			try {
				let resp;
				this.checkDynamicField = {};
				if (
					(myCandInfo.experienceLevel && myCandInfo.experienceLevel != null) ||
					myCandInfo._id != null
				) {
					resp = await dynamicMandetoryFields(myCandInfo.experienceLevel);
				} else {
					resp = await dynamicMandetoryFieldsForNew();
				}
				if (resp.status == 200) {
					this.checkDynamicField = resp.data.data;
					this.$store.commit(
						"candidateVUEX/updateAllValidation",
						this.checkDynamicField
					);
				} else {
					console.log("Response Null Api");
				}
			} catch (error) {
				console.log(error);
			}
		},

		async getTopTabsData(candsData) {
			try {
				const res = await getProfileTopTabs(candsData.industry, "progress");
				if (res.status == 200) {
					this.dynamicTabsScale = res.data.data.forms;
					this.passDynamicScale = res.data.data.forms;
					this.dynamicTabsScale = this.dynamicTabsScale.slice(0, -1);
					this.scaleTopSuccess = true;
				} else {
					this.scaleTopSuccess = false;
					console.log("Error Api");
				}
			} catch (error) {
				console.log("Error", error);
			}
		},

		async checkOverallMandetoryTabsFilled(
			checkFillFirst = false,
			dynamicScale,
			allDynamicFieldofScale,
			myCandData,
			returnVal = true
		) {
			if (Object.keys(allDynamicFieldofScale).length > 0) {
				// let dynamicTabsScale, checkDynamicField
				this.pinkFilled = [];
				this.pinkFilled = new Array(dynamicScale.length).fill(false);
				let resultsArray = null;
				if (returnVal) {
					this.finalIndexToCheckPinkFill = dynamicScale.length - 1;
				}
				for (let i = 0; i < dynamicScale.length; i++) {
					const { formID } = dynamicScale[i];

					if (formID != "demographics" && formID != "resume") {
						let minimum;
						switch (formID) {
							case "education":
							case "experience":
							case "project":
							case "achievement":
								minimum =
									allDynamicFieldofScale[formID]?.minimum != null
										? allDynamicFieldofScale[formID]?.minimum
										: 0;
								break;
							case "portfolio":
								minimum =
									allDynamicFieldofScale?.hobbies?.minimum != null
										? allDynamicFieldofScale?.hobbies?.minimum
										: 0;
								break;
							case "skills":
								minimum =
									allDynamicFieldofScale?.skills?.minimum != null
										? allDynamicFieldofScale?.skills?.minimum
										: 0;
								break;
							default:
								break;
						}
						if (formID == "skills") {
							const interpersonalSkillsMinimum =
								allDynamicFieldofScale?.interpersonalSkills?.minimum != null
									? allDynamicFieldofScale?.interpersonalSkills?.minimum
									: 0;
							const hobbyMin =
								allDynamicFieldofScale?.hobbies?.minimum != null
									? allDynamicFieldofScale?.hobbies?.minimum
									: 0;
							const onlySkill = this.checkMandetoryTabsFilled(
								formID,
								minimum,
								checkFillFirst,
								myCandData
							);
							const onlyInterSkill = this.checkMandetoryTabsFilledInterSkill(
								formID,
								interpersonalSkillsMinimum,
								checkFillFirst,
								myCandData
							);
							const onlyHobby = this.checkMandetoryTabsFilled(
								"hobbies",
								hobbyMin,
								checkFillFirst,
								myCandData
							);
							if (
								onlySkill == true &&
								onlyInterSkill == true &&
								onlyHobby === true
							) {
								resultsArray = true;
							} else {
								resultsArray = false;
							}
						} else {
							resultsArray = this.checkMandetoryTabsFilled(
								formID,
								minimum,
								checkFillFirst,
								myCandData
							);
						}
						this.pinkFilled[i] = !resultsArray;
						this.shimmerProfile = false;
					}
				}
				const hasTrueValue = this.pinkFilled.some((value) => value === true);
				if (hasTrueValue == true) {
					this.allFilledTabs = false;
				} else {
					this.allFilledTabs = true;
				}
				if (returnVal) {
					return resultsArray;
				}
			}
		},
		checkMandetoryTabsFilledInterSkill(
			formID,
			minLength,
			checkFillFirst,
			myCandData
		) {
			if (formID == "skills") {
				if (
					(myCandData.interpersonalSkills == null ||
						myCandData.interpersonalSkills.length < 1) &&
					checkFillFirst
				) {
					return false;
				} else {
					return (
						myCandData.interpersonalSkills &&
						this.ifOriginalDataPresentCount(myCandData.interpersonalSkills)
							.count >= minLength
					);
				}
			}
		},

		checkPersonalDetailsMandatoryFilled(myCandData) {
			return !!(
				myCandData.firstName &&
				myCandData.lastName &&
				myCandData.dateOfBirth &&
				myCandData.email &&
				myCandData.phoneNumber &&
				(myCandData.city || myCandData.currentLocation) &&
				myCandData.experienceLevel &&
				myCandData.profileSummary
			);
		},

		checkMandetoryTabsFilled(formID, minLength, checkFillFirst, myCandData) {
			if (formID == "personalDetails") {
				return !!myCandData.dateOfBirth;
			}
			if (formID == "education") {
				if (
					(myCandData.educationalInfo == null ||
						(myCandData.educationalInfo &&
							this.ifOriginalDataPresentCount(myCandData.educationalInfo)
								.count < 1)) &&
					checkFillFirst
				) {
					return false;
				} else {
					return (
						myCandData.educationalInfo &&
						this.ifOriginalDataPresentCount(myCandData.educationalInfo).count >=
						minLength
					);
				}
			}
			if (formID == "experience") {
				if (
					(myCandData.experience == null ||
						(myCandData.experience &&
							this.ifOriginalDataPresentCount(myCandData.experience).count <
							1)) &&
					checkFillFirst
				) {
					return false;
				} else {
					return (
						myCandData.experience &&
						this.ifOriginalDataPresentCount(myCandData.experience).count >=
						minLength
					);
				}
			}
			// if (formID == "skills") {
			// 	if (
			// 		myCandData.skills == null ||
			// 		(myCandData.skills &&
			// 			this.ifOriginalDataPresentCount(myCandData.skills).count < 1 &&
			// 			checkFillFirst)
			// 	) {
			// 		return false;
			// 	} else {
			// 		return (
			// 			myCandData.skills &&
			// 			this.ifOriginalDataPresentCount(myCandData.skills).count >=
			// 				minLength
			// 		);
			// 	}
			// 	if (
			// 				(this.candidateData.hobbies == null ||
			// 				this.candidateData.hobbies.length < 1) && checkFillFirst
			// 			) {
			// 				return false;
			// 			} else {
			// 				return (
			// 					this.candidateData.hobbies &&
			// 					this.candidateData.hobbies.length >= minLength
			// 				);
			// 			}
			// }
			if (formID === "skills") {
				// Check for skills
				if (
					myCandData.skills == null ||
					(myCandData.skills &&
						this.ifOriginalDataPresentCount(myCandData.skills).count < 1 &&
						checkFillFirst)
				) {
					return false;
				} else {
					return (
						myCandData.skills &&
						this.ifOriginalDataPresentCount(myCandData.skills).count >=
						minLength
					);
				}

				// if (
				// 	myCandData.skills &&
				// 	this.ifOriginalDataPresentCount(myCandData.skills).count >= minLength
				// ) {
				// 	// If skills validation passes, proceed to check hobbies
				// 	if (
				// 		(myCandData.hobbies == null ||
				// 			myCandData.hobbies.length < 1) &&
				// 		checkFillFirst
				// 	) {
				// 		return false;
				// 	} else {
				// 		return (
				// 			myCandData.hobbies &&
				// 			myCandData.hobbies.length >= minLength
				// 		);
				// 	}
				// }

				// // Return false if skills validation fails
				// return false;
			}

			if (formID == "project") {
				if (
					(myCandData.projects == null ||
						(myCandData.projects &&
							this.ifOriginalDataPresentCount(myCandData.projects).count <
							1)) &&
					checkFillFirst
				) {
					return false;
				} else {
					return (
						myCandData.projects &&
						this.ifOriginalDataPresentCount(myCandData.projects).count >=
						minLength
					);
				}
			}
			if (formID == "achievement") {
				if (
					myCandData.achievement &&
					this.ifOriginalDataPresentCount(myCandData.achievement).count < 1 &&
					myCandData.awards &&
					this.ifOriginalDataPresentCount(myCandData.awards).count < 1 &&
					myCandData.events &&
					this.ifOriginalDataPresentCount(myCandData.events).count < 1 &&
					checkFillFirst
				) {
					return false;
				}
				return (
					(myCandData.achievement || myCandData.awards || myCandData.events) &&
					this.ifOriginalDataPresentCount(myCandData.achievement).count +
					this.ifOriginalDataPresentCount(myCandData.awards).count +
					this.ifOriginalDataPresentCount(myCandData.events).count >=
					minLength
				);
			}
			if (formID == "hobbies") {
				return myCandData.hobbies && myCandData.hobbies.length >= minLength;
			}
			// if (formID == "portfolio") {
			// 	if (
			// 		(this.candidateData.hobbies == null ||
			// 		this.candidateData.hobbies.length < 1) && checkFillFirst
			// 	) {
			// 		return false;
			// 	} else {
			// 		return (
			// 			this.candidateData.hobbies &&
			// 			this.candidateData.hobbies.length >= minLength
			// 		);
			// 	}
			// }
		},

		ifOriginalDataPresentCount(datas) {
			let isObjectArray = datas.length > 0 && typeof datas[0] === "object";
			let count = datas.reduce(
				(accumulator, item) => {
					if (isObjectArray) {
						if (item.hasOwnProperty("priorityID")) {
							accumulator.count++;
						}
					} else {
						accumulator.count++;
					}
					return accumulator;
				},
				{ count: 0 }
			);
			return {
				hasPriorityID: datas.some((item) =>
					isObjectArray ? item.hasOwnProperty("priorityID") : false
				),
				count: count.count,
			};
		},
	},
	computed: {},
};
